/**
 * @typedef { import("vike/types").OnRenderClientAsync } OnRenderClient
 */
import '@fontsource/pt-sans-narrow/latin-400.css'
import '@fontsource/pt-sans-narrow/latin-700.css'
import '@fontsource/roboto/latin-100.css'
import '@fontsource/roboto/latin-300.css'
import '@fontsource/roboto/latin-400.css'
import '@fontsource/roboto/latin-500.css'
import '@fontsource/roboto/latin-700.css'
import '@fontsource/roboto/latin-900.css'

import { tracker } from '#root/lib/tracker'
import { createApp } from './app'

export default onRenderClient

/**
 * @type OnRenderClient
 */
async function onRenderClient(pageContext) {
  const app = createApp(pageContext)
  tracker.pageView(pageContext)
  app.mount('#app')
}
